export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_R1.c33447e6.png";